import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const CandidateStatistics = ({ totalCandidatesConstant }) => (
  <div className={`count-details-grid ${styles.countDetailsGrid}`}>
    <div className={`icon-text-column ${styles.iconTextColumn}`}>
      <img src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/trend_icon.svg`} />
      <p>
        <span>{process.env.NEXT_PUBLIC_CANDIDATES_TREND_COUNT}</span> candidates went live in the last 3 months
      </p>
    </div>
    <div className={`icon-text-column ${styles.iconTextColumn}`}>
      <img src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/profile_icon.svg`} />
      <p>
        <span>{totalCandidatesConstant}</span> candidates are actively interviewing right now
      </p>
    </div>
    <div className={`icon-text-column ${styles.iconTextColumn}`}>
      <img src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/location_icon.svg`} />
      <p>
        Active candidates are job seeking across <span>{process.env.NEXT_PUBLIC_CANDIDATES_LOCATION_COUNT}+</span> cities
      </p>
    </div>
  </div>
)

CandidateStatistics.propTypes = {
  totalCandidatesConstant: PropTypes.number,
}

export default CandidateStatistics
